import React from "react";
import { More, Strip } from "./ThumbnailStrip.styles";
import type { ThumbnailStripProps } from "./ThumbnailStrip.types";

/** A row of small page thumbnails with an optional "+N" tile. Decorative. */
export const ThumbnailStrip: React.FC<ThumbnailStripProps> = ({ thumbnails, moreLabel, columns = 3, portrait = false, size = "md", className }) => (
  <Strip aria-hidden="true" $columns={columns} $portrait={portrait} $size={size} className={className} data-testid="thumbnail-strip">
    {thumbnails.map((thumbnail, index) => (
      <React.Fragment key={index}>{thumbnail}</React.Fragment>
    ))}
    {moreLabel ? <More>{moreLabel}</More> : null}
  </Strip>
);

export default ThumbnailStrip;
